export default {
	init: function () {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/orders.js